import React from 'react'
import { Heading, Stack, Table, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react'
import { QualificationDetails } from '@homevest/types/rental-applications'
import { rentalApplications } from '@homevest/utils'
import { formatMoney } from 'lib/numbers'

export const ApplicantSummaryPanel = ({
  qualificationDetails
}: {
  qualificationDetails: QualificationDetails
}) => {
  const { applicants, underwriting_methodology } = qualificationDetails
  const isSaferent =
    underwriting_methodology === rentalApplications.UNDERWRITING_METHODOLOGIES.SAFERENT

  return (
    <Stack>
      <Heading size='md'>Applicants</Heading>
      <Table>
        <Thead>
          <Tr>
            <Th>Applicant</Th>
            <Th>Ann. Income</Th>
            <Th>Credit</Th>
            <Th>Criminal</Th>
            <Th>{isSaferent ? 'Alerts' : 'Eviction'}</Th>
          </Tr>
        </Thead>
        <Tbody>
          {applicants.map((applicant) => {
            const nonIncomeApplicantDecor = applicant.is_non_income_applicant
              ? 'line-through'
              : undefined
            const criminalCheckStatus =
              applicant.criminal_check_clear === undefined
                ? '❓'
                : applicant.criminal_check_clear
                ? '✅'
                : '🟧'
            const evictionCheckStatus =
              applicant.eviction_check_clear === undefined
                ? '❓'
                : applicant.eviction_check_clear
                ? '✅'
                : '🟧'
            return (
              <Tr key={applicant.user_id}>
                <Td>{applicant.name}</Td>
                <Td textDecor={nonIncomeApplicantDecor} textDecorationThickness='2px'>
                  {applicant.gross_annual_income
                    ? formatMoney(applicant.gross_annual_income, 2, '$')
                    : '-'}
                </Td>
                <Td
                  color={creditScoreColor(applicant.credit_score)}
                  textDecor={nonIncomeApplicantDecor}
                  textDecorationThickness='2px'
                >
                  {applicant.credit_score ?? '❓'}
                </Td>
                <Td>{criminalCheckStatus}</Td>
                <Td>{evictionCheckStatus}</Td>
              </Tr>
            )
          })}
        </Tbody>
      </Table>
    </Stack>
  )
}

const creditScoreColor = (creditScore: number | null) => {
  if (!creditScore) {
    return undefined
  }

  if (creditScore >= 620) {
    return 'green'
  }

  if (creditScore >= 600) {
    return 'orange'
  }

  return 'red'
}
